import React from 'react'

import {
  Divider,
  IconButton,
  Typography
} from '@mui/material'
import { ArrowBack } from '@mui/icons-material'

import MailMessage from '../molecules/MailMessage'

const MailDetailContent = (props) => {
  const { activeMessageDetail, setActiveMessageDetail } = props

  const closeDetail = () => {
    setActiveMessageDetail(null)
  }

  return (
    <>
      <Divider/>
      <div className='flex items-center p-2'>
        <IconButton
          onClick={closeDetail}
          color='primary'
        >
          <ArrowBack/>
        </IconButton>
        <Typography className='text-ellipsis'>
          {activeMessageDetail?.subject}
        </Typography>
      </div>
      <Divider/>
      <div style={{ minHeight: '100%' }} className='p-4'>
        {!!activeMessageDetail &&
          <>
            <MailMessage message={activeMessageDetail}/>
            {activeMessageDetail?.replies?.map((item, index) =>
              <MailMessage message={item} key={index}/>
            )}
          </>
        }
      </div>
    </>
  )
}

export default MailDetailContent
